export const formatDate = (dateString: string, isUTC: boolean) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const options: Intl.DateTimeFormatOptions = {
        hour: '2-digit',
        minute: '2-digit',
        hourCycle: 'h23',
        timeZone: isUTC ? 'UTC' : 'Asia/Kuala_Lumpur',
    };
    return new Intl.DateTimeFormat('en-US', options).format(date);
};

export const getLocalTimeAbbreviation = (date: Date = new Date()): string =>{
  const formatter = new Intl.DateTimeFormat('en-US', {
    timeZoneName: 'short',
  });
  const parts = formatter.formatToParts(date);
  const tz = parts.find(p => p.type === 'timeZoneName');
  return tz?.value || '';
}

